/**
 * Creative Actions
 */

export const CREATIVES_ACTIONS = {
	RESET_CREATIVES_LIST			:"RESET_CREATIVES_LIST",
	LOAD_CREATIVES_AJAX				:"LOAD_CREATIVES_AJAX",
	LOAD_CREATIVES_SUCCESS			:"LOAD_CREATIVES_SUCCESS",
	LOAD_CREATIVES_ERROR			:"LOAD_CREATIVES_ERROR",
	LOAD_CREATIVES_CANCEL			:"LOAD_CREATIVES_CANCEL",

	LOAD_CREATIVES_DISTINCTS_AJAX	:"LOAD_CREATIVES_DISTINCTS_AJAX",
	LOAD_CREATIVES_DISTINCTS_SUCCESS:"LOAD_CREATIVES_DISTINCTS_SUCCESS",
	LOAD_CREATIVES_DISTINCTS_ERROR	:"LOAD_CREATIVES_DISTINCTS_ERROR",

	FETCH_CREATIVE_FILENAME_CONFLICTS_AJAX: "FETCH_CREATIVE_FILENAME_CONFLICTS_AJAX",
	FETCH_CREATIVE_FILENAME_CONFLICTS_SUCCESS: "FETCH_CREATIVE_FILENAME_CONFLICTS_SUCCESS",
	FETCH_CREATIVE_FILENAME_CONFLICTS_ERROR: "FETCH_CREATIVE_FILENAME_CONFLICTS_ERROR",

	UPLOAD_CREATIVE_AJAX:"UPLOAD_CREATIVE_AJAX",
	UPLOAD_CREATIVE_SUCCESS:"UPLOAD_CREATIVE_SUCCESS",
	UPLOAD_CREATIVE_ERROR:"UPLOAD_CREATIVE_ERROR",

	BULK_STATUS_CHANGE_AJAX: "BULK_STATUS_CHANGE_AJAX",
	BULK_STATUS_CHANGE_SUCCESS: "BULK_STATUS_CHANGE_SUCCESS",
	BULK_STATUS_CHANGE_ERROR: "BULK_STATUS_CHANGE_ERROR",

	STATUS_CHANGE_AJAX				:"STATUS_CHANGE_AJAX",
	STATUS_CHANGE_SUCCESS			:"STATUS_CHANGE_SUCCESS",
	STATUS_CHANGE_ERROR				:"STATUS_CHANGE_ERROR",
	RENAME_CREATIVE_AJAX			:"RENAME_CREATIVE_AJAX",
	RENAME_CREATIVE_SUCCESS			:"RENAME_CREATIVE_SUCCESS",
	RENAME_CREATIVE_ERROR			:"RENAME_CREATIVE_ERROR",

	RENAME_CREATIVE_FILENAME_AJAX	:"RENAME_CREATIVE_FILENAME_AJAX",
	RENAME_CREATIVE_FILENAME_SUCCESS:"RENAME_CREATIVE_FILENAME_SUCCESS",
	RENAME_CREATIVE_FILENAME_ERROR	:"RENAME_CREATIVE_FILENAME_ERROR",

	DELETE_CREATIVES_AJAX: "DELETE_CREATIVES_AJAX",
	DELETE_CREATIVES_SUCCESS: "DELETE_CREATIVES_SUCCESS",
	DELETE_CREATIVES_ERROR: "DELETE_CREATIVES_ERROR",

	DUPLICATE_CREATIVES_AJAX: "DUPLICATE_CREATIVES_AJAX",
	DUPLICATE_CREATIVES_SUCCESS: "DUPLICATE_CREATIVES_SUCCESS",
	DUPLICATE_CREATIVES_ERROR: "DUPLICATE_CREATIVES_ERROR",

	//Downloads
	DOWNLOAD_CREATIVE_AJAX:            "DOWNLOAD_CREATIVE_AJAX",
	DOWNLOAD_CREATIVE_SUCCESS:         "DOWNLOAD_CREATIVE_SUCCESS",
	DOWNLOAD_CREATIVE_ERROR:           "DOWNLOAD_CREATIVE_ERROR",
	DOWNLOAD_CREATIVE_SUMMARY_AJAX:    "DOWNLOAD_CREATIVE_SUMMARY_AJAX",
	DOWNLOAD_CREATIVE_SUMMARY_SUCCESS: "DOWNLOAD_CREATIVE_SUMMARY_SUCCESS",
	DOWNLOAD_CREATIVE_SUMMARY_ERROR:   "DOWNLOAD_CREATIVE_SUMMARY_ERROR",

	UPLOAD_CLOSED_CAPTION_AJAX:    "UPLOAD_CLOSED_CAPTION_AJAX",
	UPLOAD_CLOSED_CAPTION_SUCCESS: "UPLOAD_CLOSED_CAPTION_SUCCESS",
	UPLOAD_CLOSED_CAPTION_ERROR:   "UPLOAD_CLOSED_CAPTION_ERROR",
	DELETE_CLOSED_CAPTION_AJAX:    "DELETE_CLOSED_CAPTION_AJAX",
	DELETE_CLOSED_CAPTION_SUCCESS: "DELETE_CLOSED_CAPTION_SUCCESS",
	DELETE_CLOSED_CAPTION_ERROR:   "DELETE_CLOSED_CAPTION_ERROR",

	ADD_CREATIVE_FROM_SOCKET:"ADD_CREATIVE_FROM_SOCKET",
	UPDATE_APPROVALS_FROM_SOCKET:"UPDATE_APPROVALS_FROM_SOCKET",
	UPDATE_CREATIVE_VERIONS_COUNTS_FROM_SOCKET:"UPDATE_CREATIVE_VERIONS_COUNTS_FROM_SOCKET",

	SET_ACTIVE_CREATIVE: "SET_ACTIVE_CREATIVE",
	CLEAR_ACTIVE_CREATIVE: "CLEAR_ACTIVE_CREATIVE",

	FETCH_CREATIVES_BY_ID: "FETCH_CREATIVES_BY_ID",
	FETCH_CREATIVES_BY_ID_SUCCESS: "FETCH_CREATIVES_BY_ID_SUCCESS",
	FETCH_CREATIVES_BY_ID_ERROR: "FETCH_CREATIVES_BY_ID_ERROR",
};

export const CREATIVE_DETAILS_ACTIONS = {
	CLEAR_CREATIVE_DETAILS: "CLEAR_CREATIVE_DETAILS",

	CREATE_LIBRARY_AJAX: "CREATE_LIBRARY_AJAX",
	CREATE_LIBRARY_SUCCESS: "CREATE_LIBRARY_SUCCESS",
	CREATE_LIBRARY_ERROR: "CREATE_LIBRARY_ERROR",

	LOAD_CREATIVE_AJAX: "LOAD_CREATIVE_AJAX",
	LOAD_CREATIVE_SUCCESS: "LOAD_CREATIVE_SUCCESS",
	LOAD_CREATIVE_ERROR: "LOAD_CREATIVE_ERROR",

	LOAD_CREATIVE_VARIABLES_AJAX: "LOAD_CREATIVE_VARIABLES_AJAX",
	LOAD_CREATIVE_VARIABLES_SUCCESS: "LOAD_CREATIVE_VARIABLES_SUCCESS",
	LOAD_CREATIVE_VARIABLES_ERROR: "LOAD_CREATIVE_VARIABLES_ERROR",

	UPDATE_CREATIVE_AJAX: "UPDATE_CREATIVE_AJAX",
	UPDATE_CREATIVE_SUCCESS: "UPDATE_CREATIVE_SUCCESS",
	UPDATE_CREATIVE_ERROR: "UPDATE_CREATIVE_ERROR",

	UPDATE_SOCIAL_CREATIVE_AJAX:    "UPDATE_SOCIAL_CREATIVE_AJAX",
	UPDATE_SOCIAL_CREATIVE_SUCCESS: "UPDATE_SOCIAL_CREATIVE_SUCCESS",
	UPDATE_SOCIAL_CREATIVE_ERROR:   "UPDATE_SOCIAL_CREATIVE_ERROR",

	UPDATE_SOCIAL2_CREATIVE_AJAX:    "UPDATE_SOCIAL2_CREATIVE_AJAX",
	UPDATE_SOCIAL2_CREATIVE_SUCCESS: "UPDATE_SOCIAL2_CREATIVE_SUCCESS",
	UPDATE_SOCIAL2_CREATIVE_ERROR:   "UPDATE_SOCIAL2_CREATIVE_ERROR",

	NATIVE_CREATIVE_AJAX:"NATIVE_CREATIVE_AJAX",
	NATIVE_CREATIVE_SUCCESS:"NATIVE_CREATIVE_SUCCESS",
	NATIVE_CREATIVE_ERROR:"NATIVE_CREATIVE_ERROR",
};

export const CREATIVE_VAST_ACTIONS = {
	LOAD_CREATIVE_VAST_SPECS_AJAX:"LOAD_CREATIVE_VAST_SPECS_AJAX",
	LOAD_CREATIVE_VAST_SPECS_SUCCESS:"LOAD_CREATIVE_VAST_SPECS_SUCCESS",
	LOAD_CREATIVE_VAST_SPECS_ERROR:"LOAD_CREATIVE_VAST_SPECS_ERROR",

	LOAD_CREATIVE_VAST_AUDIO_SPECS_AJAX:"LOAD_CREATIVE_VAST_AUDIO_SPECS_AJAX",
	LOAD_CREATIVE_VAST_AUDIO_SPECS_SUCCESS:"LOAD_CREATIVE_VAST_AUDIO_SPECS_SUCCESS",
	LOAD_CREATIVE_VAST_AUDIO_SPECS_ERROR:"LOAD_CREATIVE_VAST_AUDIO_SPECS_ERROR",

	SET_UPLOAD_LIST:"SET_UPLOAD_LIST",

	UPLOAD_VAST_CREATIVE_AJAX:"UPLOAD_VAST_CREATIVE_AJAX",
	UPLOAD_VAST_CREATIVE_SUCCESS:"UPLOAD_VAST_CREATIVE_SUCCESS",
	UPLOAD_VAST_CREATIVE_ERROR:"UPLOAD_VAST_CREATIVE_ERROR",
	UPLOAD_VAST_CREATIVE_PROGRESS:"UPLOAD_VAST_CREATIVE_PROGRESS",

	ENCODE_VAST_CREATIVES_AJAX: "ENCODE_VAST_CREATIVES_AJAX",
	ENCODE_VAST_CREATIVES_SUCCESS: "ENCODE_VAST_CREATIVES_SUCCESS",
	ENCODE_VAST_CREATIVES_ERROR: "ENCODE_VAST_CREATIVES_ERROR",

	UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_AJAX: "UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_AJAX",
	UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_SUCCESS: "UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_SUCCESS",
	UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_ERROR: "UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_ERROR",
	UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_PROGRESS: "UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_PROGRESS",

	UPLOAD_VAST_IMPOSIUM_CREATIVES_AJAX: "UPLOAD_VAST_IMPOSIUM_CREATIVES_AJAX",
	UPLOAD_VAST_IMPOSIUM_CREATIVES_SUCCESS: "UPLOAD_VAST_IMPOSIUM_CREATIVES_SUCCESS",
	UPLOAD_VAST_IMPOSIUM_CREATIVES_ERROR: "UPLOAD_VAST_IMPOSIUM_CREATIVES_ERROR",

	ENCODE_VAST_IMPOSIUM_CREATIVES_AJAX: "ENCODE_VAST_IMPOSIUM_CREATIVES_AJAX",
	ENCODE_VAST_IMPOSIUM_CREATIVES_SUCCESS: "ENCODE_VAST_IMPOSIUM_CREATIVES_SUCCESS",
	ENCODE_VAST_IMPOSIUM_CREATIVES_ERROR: "ENCODE_VAST_IMPOSIUM_CREATIVES_ERROR",

	ENCODE_AFTER_EFFECTS_CREATIVES_AJAX: "ENCODE_AFTER_EFFECTS_CREATIVES_AJAX",
	ENCODE_AFTER_EFFECTS_CREATIVES_SUCCESS: "ENCODE_AFTER_EFFECTS_CREATIVES_SUCCESS",
	ENCODE_AFTER_EFFECTS_CREATIVES_ERROR: "ENCODE_AFTER_EFFECTS_CREATIVES_ERROR",

	UPLOAD_VAST_AUDIO_CREATIVE_AJAX:"UPLOAD_VAST_AUDIO_CREATIVE_AJAX",
	UPLOAD_VAST_AUDIO_CREATIVE_SUCCESS:"UPLOAD_VAST_AUDIO_CREATIVE_SUCCESS",
	UPLOAD_VAST_AUDIO_CREATIVE_ERROR:"UPLOAD_VAST_AUDIO_CREATIVE_ERROR",
	UPLOAD_VAST_AUDIO_CREATIVE_PROGRESS:"UPLOAD_VAST_AUDIO_CREATIVE_PROGRESS",

	ENCODE_VAST_AUDIO_CREATIVES_AJAX: "ENCODE_VAST_AUDIO_CREATIVES_AJAX",
	ENCODE_VAST_AUDIO_CREATIVES_SUCCESS: "ENCODE_VAST_AUDIO_CREATIVES_SUCCESS",
	ENCODE_VAST_AUDIO_CREATIVES_ERROR: "ENCODE_VAST_AUDIO_CREATIVES_ERROR",

	CREATE_BLANK_IMPOSIUM_CREATIVE_AJAX: "CREATE_BLANK_IMPOSIUM_CREATIVE_AJAX",
	CREATE_BLANK_IMPOSIUM_CREATIVE_SUCCESS: "CREATE_BLANK_IMPOSIUM_CREATIVE_SUCCESS",
	CREATE_BLANK_IMPOSIUM_CREATIVE_ERROR: "CREATE_BLANK_IMPOSIUM_CREATIVE_ERROR",

	// Audio Imposium Actions
	UPLOAD_AUDIO_IMPOSIUM_CREATIVE_AJAX: "UPLOAD_AUDIO_IMPOSIUM_CREATIVE_AJAX",
	UPLOAD_AUDIO_IMPOSIUM_CREATIVE_SUCCESS: "UPLOAD_AUDIO_IMPOSIUM_CREATIVE_SUCCESS",
	UPLOAD_AUDIO_IMPOSIUM_CREATIVE_ERROR: "UPLOAD_AUDIO_IMPOSIUM_CREATIVE_ERROR",
	UPLOAD_AUDIO_IMPOSIUM_CREATIVE_PROGRESS: "UPLOAD_AUDIO_IMPOSIUM_CREATIVE_PROGRESS",

	ENCODE_AUDIO_IMPOSIUM_CREATIVES_AJAX: "ENCODE_AUDIO_IMPOSIUM_CREATIVES_AJAX",
	ENCODE_AUDIO_IMPOSIUM_CREATIVES_SUCCESS: "ENCODE_AUDIO_IMPOSIUM_CREATIVES_SUCCESS",
	ENCODE_AUDIO_IMPOSIUM_CREATIVES_ERROR: "ENCODE_AUDIO_IMPOSIUM_CREATIVES_ERROR",

	CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_AJAX: "CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_AJAX",
	CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_SUCCESS: "CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_SUCCESS",
	CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_ERROR: "CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_ERROR",

	CREATE_PARTNER_VAST_AJAX:"CREATE_PARTNER_VAST_AJAX",
	CREATE_PARTNER_VAST_SUCCESS:"CREATE_PARTNER_VAST_SUCCESS",
	CREATE_PARTNER_VAST_ERROR:"CREATE_PARTNER_VAST_ERROR",

	EDIT_PARTNER_VAST_AJAX:"EDIT_PARTNER_VAST_AJAX",
	EDIT_PARTNER_VAST_SUCCESS:"EDIT_PARTNER_VAST_SUCCESS",
	EDIT_PARTNER_VAST_ERROR:"EDIT_PARTNER_VAST_ERROR",

	CREATE_YOUTUBE_URL_CREATIVE_AJAX:"CREATE_YOUTUBE_URL_CREATIVE_AJAX",
	CREATE_YOUTUBE_URL_CREATIVE_SUCCESS:"CREATE_YOUTUBE_URL_CREATIVE_SUCCESS",
	CREATE_YOUTUBE_URL_CREATIVE_ERROR:"CREATE_YOUTUBE_URL_CREATIVE_ERROR",

	IMPORT_YOUTUBE_URL_CREATIVES_AJAX:"IMPORT_YOUTUBE_URL_CREATIVES_AJAX",
	IMPORT_YOUTUBE_URL_CREATIVES_SUCCESS:"IMPORT_YOUTUBE_URL_CREATIVES_SUCCESS",
	IMPORT_YOUTUBE_URL_CREATIVES_ERROR:"IMPORT_YOUTUBE_URL_CREATIVES_ERROR",

	POLL_YOUTUBE_IMPORT_JOB_AJAX:"POLL_YOUTUBE_IMPORT_JOB_AJAX",
	POLL_YOUTUBE_IMPORT_JOB_SUCCESS:"POLL_YOUTUBE_IMPORT_JOB_SUCCESS",
	POLL_YOUTUBE_IMPORT_JOB_ERROR:"POLL_YOUTUBE_IMPORT_JOB_ERROR",
	POLL_YOUTUBE_IMPORT_JOB_TIMEOUT:"POLL_YOUTUBE_IMPORT_JOB_TIMEOUT",
};

export const CREATIVE_TAXONOMY_ACTIONS = {
	CLASSIFY_CREATIVES_AJAX: "CLASSIFY_CREATIVES_AJAX",
	CLASSIFY_CREATIVES_SUCCESS: "CLASSIFY_CREATIVES_SUCCESS",
	CLASSIFY_CREATIVES_ERROR: "CLASSIFY_CREATIVES_ERROR",

	IMPORT_CREATIVE_LABELS_AJAX: "IMPORT_CREATIVE_LABELS_AJAX",
	IMPORT_CREATIVE_LABELS_SUCCESS: "IMPORT_CREATIVE_LABELS_SUCCESS",
	IMPORT_CREATIVE_LABELS_ERROR: "IMPORT_CREATIVE_LABELS_ERROR",
};

export const GENERATE_AUDIO_ACTIONS = {
	LOAD_VOICE_SETTINGS: 'LOAD_VOICE_SETTINGS',
	LOAD_VOICES: 'LOAD_VOICES',
	LOAD_SOUND_MOODS: 'LOAD_SOUND_MOODS',
	LOAD_SOUND_SETTINGS: 'LOAD_SOUND_SETTINGS',
	LOAD_SOUNDS: 'LOAD_SOUNDS',
	CREATE_VERSIONS: 'CREATE_VERSIONS',
	GENERATE_AUDIO: 'GENERATE_AUDIO',
};
